import type {IntlShape} from 'react-intl';
import {createToast} from '../toasts/another-toast/toaster';
import type {InvokeResult} from './novaInvocationStore';

// An AI access refusal is raised before a run exists, so nothing is saved and no turn on the thread
// can say why the run did not start. This toast is the only place the person learns the reason, and
// that an administrator is the one who can lift it. Returns whether it showed one.
export function toastIfAiAccessRemoved(result: InvokeResult, formatMessage: IntlShape['formatMessage']): boolean {
	if (result.kind !== 'failed' || result.cause !== 'no_ai_access') return false;
	createToast({duration: 5000, message: formatMessage({id: 'nova_invocation.failure.cause.no_ai_access'})});
	return true;
}
